export enum ROUTES {
  COMPLETE_REGISTRATION = '/register',
  ACCOUNT_CONSENT = '/account-consent',
  BUNDLING_UPGRADE = '/bundling-upgrade',
  SPOTIFY_UPGRADE = '/spotify-upgrade',
  SPOTIFY_ERROR = '/spotify-error',
  INVITATION_ACCEPT = '/invite',
  INVITATION_ERROR = '/invite-error',
  INTERNAL_ERROR = '/error',
}
